import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as CharitySvg } from './assets/charity.svg';

const CharityIcon = React.forwardRef((args, ref) => <SvgIcon component={CharitySvg} ref={ref} {...args} />);

export default CharityIcon;
